module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_19_2.b3d741f3.jpeg";